<template>
    <b-container>
        <b-card v-if="userName===null && userData.username===null">
            <h4> Create a new User </h4>
            <b-breadcrumb>
            <b-breadcrumb-item :to="{name: 'user-list'}">Back to Users</b-breadcrumb-item>
            <b-breadcrumb-item active>New User</b-breadcrumb-item>
            </b-breadcrumb>

        </b-card>
        <b-card v-if="userName!==null || userData.username!==null">
            <b-breadcrumb>
                <b-breadcrumb-item :to="{name: 'user-list'}">Back to Users</b-breadcrumb-item>
                <b-breadcrumb-item active> Modify: {{userData.full_name || userName  }}</b-breadcrumb-item>
            </b-breadcrumb>
            <h4> User: {{userData.username || userName  }} </h4>
        </b-card>
        <b-card>
        <b-dropdown text="Actions">
            <b-dropdown-item v-if="isInRole('canCreateUsers')" :to="{name: 'change-credentials', params:{'userName': this.userName}}"><font-awesome-icon icon="key" /> Reset Password</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item v-if="isInRole('canViewUsers')"  :to="{name: 'user-list'}"><font-awesome-icon icon="eye" /> View Application Users </b-dropdown-item>
        </b-dropdown>
        </b-card>
        <b-card>
            <b-form @submit="onSubmit">
                <b-form-group
                    v-if="isInRole('canCreateUsers')&& userName===null"
                    id="username"
                    label="Username:"
                    label-for="username">
                    <b-form-input
                        id="username"
                        v-model="userData.username"
                        type="text"
                        placeholder="Your new username"
                        required
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-1"
                    label="Email:"
                    label-for="input-1"
                    description="User Email">
                    <b-form-input
                        id="input-1"
                        v-model="userData.email"
                        type="email"
                        placeholder="Email"
                        required
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-2"
                    label="Full Name:"
                    label-for="input-2"
                    description="Full Name">
                    <b-form-input
                        id="input-2"
                        v-model="userData.full_name"
                        type="text"
                        placeholder="Full user name"
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-4"
                    label="Default Stake:"
                    label-for="input-4"
                    v-if="isInRole('canAssignStake')"
                    description="Stake Id to default when logging in.">
                    <b-form-select
                        id="input-4"
                        v-model="userData.stake_id"
                        :options="stakeOptions"
                        type="text"
                        v-on:change="getStakeWardOptions"
                        placeholder="Stake UUID"
                    ></b-form-select>
                </b-form-group>
                <b-form-group
                    id="input-group-3"
                    label="Default Ward:"
                    label-for="input-3"
                    v-if="isInRole('canAssignWard')"
                    description="Ward Id to default when logging in.">
                    <b-form-select
                        id="input-3"
                        v-model="userData.ward_id"
                        :options="wardOptions"
                        type="text"
                        placeholder="Ward UUID"
                    ></b-form-select>
                </b-form-group>
                <!--<b-form-group
                    v-if="isInRole('canCreateUsers')&& userName===null"
                    id="password"
                    label="Password:"
                    label-for="password">
                    <b-form-input
                        id="password"
                        v-model="password"
                        type="password"
                        placeholder="Secret Password"
                        required
                    ></b-form-input>
                </b-form-group>-->
                <b-form-checkbox
                    v-if="isInRole('canCreateUsers')"
                    v-model="userData.change_pass_on_login"
                    class="mb-4"
                    name="check-button" switch>
                    Required Password Change
                </b-form-checkbox>
                <b-form-group
                    v-if="isInRole('canModifyEmailNotifications')"
                  label="Select e-mail notifications to receive"
                  v-slot="{ ariaDescribedby }"
                >
                  <b-form-checkbox-group
                    v-model="emailOptionsSelected"
                    :options="emailOptions"
                    :aria-describedby="ariaDescribedby"
                    switches
                  ></b-form-checkbox-group>
                </b-form-group>

                <b-form-group label="Select User Permissions:" label-for="tags-component-select">
                  <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
                  <b-form-tags
                    id="tags-component-select"
                    v-model="userData.application_roles"
                    size="lg"
                    class="mb-2"
                    add-on-change
                    no-outer-focus
                  >
                    <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
                      <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
                        <li v-for="tag in tags" :key="tag" class="list-inline-item">
                          <b-form-tag
                            @remove="removeTag(tag)"
                            :title="tag"
                            :disabled="disabled"
                            variant="info"
                          >{{ tag }}</b-form-tag>
                        </li>
                      </ul>
                      <b-form-select
                        v-bind="inputAttrs"
                        v-on="inputHandlers"
                        :disabled="disabled || availableOptions.length === 0"
                        :options="availableOptions"
                      >
                        <template #first>
                          <!-- This is required to prevent bugs with Safari -->
                          <option disabled value="">Choose a Permission to Add...</option>
                        </template>
                      </b-form-select>
                    </template>
                  </b-form-tags>
                </b-form-group>

                <b-form-group v-if="isInRole('canRestrictOrgs')" label="Messsages Restricted To:" label-for="tags-component-select-orgs">
                  <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
                  <b-form-tags
                    id="tags-component-select-orgs"
                    v-model="userData.restrict_to_orgs"
                    size="lg"
                    class="mb-2"
                    add-on-change
                    no-outer-focus
                  >
                    <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
                      <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
                        <li v-for="tag in tags" :key="tag" class="list-inline-item">
                          <b-form-tag
                            @remove="removeTag(tag)"
                            :title="tag"
                            :disabled="disabled"
                            variant="info"
                          >{{ tag }}</b-form-tag>
                        </li>
                      </ul>
                      <b-form-select
                        v-bind="inputAttrs"
                        v-on="inputHandlers"
                        :disabled="disabled || availableOrganizations.length === 0"
                        :options="availableOrganizations"
                      >
                        <template #first>
                          <!-- This is required to prevent bugs with Safari -->
                          <option disabled value="">Choose a Organization to restrict messages to...</option>
                        </template>
                      </b-form-select>
                    </template>
                  </b-form-tags>
                </b-form-group>


                <b-form-checkbox
                    v-if="isInRole('canCreateUsers')"
                    v-model="userData.disabled"
                    name="check-button"
                    switch class="mb-4">
                    User Disabled
                </b-form-checkbox>
                <b-button type="submit" variant="primary"> {{buttonText}}</b-button>
            </b-form>
        </b-card>
    </b-container>
</template>
<script>
import {UserApi} from "@/api/userApi";
import { StakeApi } from "@/app/stakes/stakeApi";
import { userMixin } from "@/mixins/userMixin";
import { organizationMixin } from "@/mixins/organizationMixin";
import handleError from "@/errorHandler";
export default {
    name: "UserDetail",
    mixins: [userMixin, organizationMixin],
    props: {
        userName: {
            type: String,
            required: false,
            default: null
        }
    },
    data () {
        return {
            options: [],
            emailOptions: [],
            emailOptionsSelected: [],
            userData: {
                username: null,
                password: null,
                email: null,
                full_name: null,
                ward_id: null,
                stake_id: null,
                application_roles: [],
                disabled: false,
                change_pass_on_login: false,
                email_alerts: [],
                restrict_to_orgs: []
            },
            password: null,
            change_pass_on_login: false,
            stakeOptions: [],
            wardOptions: [],
            orgOptions: [],
        }
    },
    computed:{
        buttonText(){
            if(this.userName !== null)
                return "Update"
            return "Create"
        },
        availableOptions() {
            return this.options.filter(opt=>this.userData.application_roles.indexOf(opt.value) === -1);
        },
        availableEmailOptions() {
            return this.emailOptions.filter(opt=>this.userData.email_alerts.indexOf(opt.value) === -1);
        },
        availableOrganizations() {
            return this.allOrganizations.filter(opt => this.userData.restrict_to_orgs.indexOf(opt.value) === -1);
        }
    },
    async mounted() {
        this.options = this.$store.state.frontEndSettings.application_roles;
        this.emailOptions = this.$store.state.frontEndSettings.email_types;
        if(this.userName !== null)
            await this.getMe();

        await this.getStakeOptions();
        await this.getStakeWardOptions();
        if(this.userData.ward_id !== null){
            await this.getStakeWardOrganizations(this.userData.ward_id);
        }

    },
    methods: {
        async getMe() {
            const { data } = await UserApi.getUserDetail(this.userName);
            //console.log(data);
            this.userData = data;
            if (data.email_alerts !== null)
                this.emailOptionsSelected = data.email_alerts;
        },
        async onSubmit(event) {
            event.preventDefault();
            let data = {
                username: this.userData.username,
                email: this.userData.email,
                full_name: this.userData.full_name,
                application_roles: this.userData.application_roles,
                disabled: this.userData.disabled,
                ward_id: this.userData.ward_id,
                stake_id: this.userData.stake_id,
                change_pass_on_login: this.userData.change_pass_on_login,
                email_alerts: this.emailOptionsSelected,
                restrict_to_orgs: this.userData.restrict_to_orgs
            };
            try{
                if(this.userName !== null)
                {
                    //console.log(data);
                    const {response} = await UserApi.updateUserDetail(this.userName, data);
                    this.getUserProfile(false);
                    this.$toast.success("Successfully Updated User");
                    //console.log(response);
                }else{
                    //data.password = this.password;
                    data.change_pass_on_login = this.userData.change_pass_on_login;
                    //console.log(data);
                    const { response } = await UserApi.createUser(data);
                    this.getUserProfile(false);
                    this.$toast.success("Successfully Created User")
                    //console.log("Update Someone else");
                }
                await this.$router.push({ name: 'user-list' });
            }catch(e) {
               if (this.userName !== null)
                  handleError(e, "Could not update user");
                else
                  handleError(e, "Could not create user");

            }
        },
        async getStakeOptions() {
            if(this.isInRole('canCreateUsers')){
                try{
                    let response  = await StakeApi.getStakeOptionList();
                    this.stakeOptions = response.data;

                }catch(e) {
                    handleError(e, "Could not fetch stake options");
                }
            }
        },
        async getStakeWardOptions() {
            if(this.isInRole('canCreateUsers')){
                try{
                    if(this.userData.stake_id===null) return;
                    let response = await StakeApi.getStakeWardOptionsList(this.userData.stake_id);
                    this.wardOptions = response.data;
                }catch(e) {
                    handleError(e, "Could not fetch wards");

                }
            }
        },
        async getStakeWardOrganizations() {
            if(this.isInRole('canCreateUsers')){
                try{
                    if(this.userData.ward_id===null) return;
                    await this.getOrganizations(this.userData.ward_id);
                }catch(e) {
                    handleError(e, 'Could not fetch organizations for ward')
                }
            }

        }

    }
}
</script>
<style lang="scss" scoped>
</style>
